import { lazy, Suspense } from "react"

import useChampionsTrackingStore from "~/store/champions-tracking"

const MessageTemplateModal = lazy(
  () => import("~/containers/champions-tracking/email-template-modal")
)

const ModalComponents = () => {
  const showMessageTemplateModal = useChampionsTrackingStore(
    (store) => store.showMessageTemplateModal
  )
  return (
    <Suspense>{showMessageTemplateModal && <MessageTemplateModal />}</Suspense>
  )
}

export default ModalComponents
